import { SET_TODOS, ADD_TODO, DELETE_TODO, UPDATE_TODO, SET_ACTIVE_TODOS, SET_FINISHED_TODOS, DELETE_ACTIVE_TODO, DELETE_FINISHED_TODO } from './action'

const initialState = {
  todos: [
    {
      id: 1,
      title: 'Mengerjakan Holiday Challenge',
      status: 'unfinished'
    }
  ],
  activeTodos: [],
  finishedTodos: []
}

export default function reducer (state = initialState, action) {
  const { type, payload } = action
  switch (type) {
    case SET_TODOS:
      return { ...state, todos: payload }
    case ADD_TODO:
      return { ...state, todos: state.todos.concat(payload) }
    case UPDATE_TODO:
      let updatedTodos = state.todos.filter(todo => todo.id !== payload.id)
      let updatedActiveTodos = state.activeTodos.filter(todo => todo.id !== payload.id)
      let updatedFinishedTodos = state.finishedTodos.filter(todo => todo.id !== payload.id)
      const { index, id, title, status, info } = payload
      console.log(info, '<<<<<< info')
      const newPayload = {
        id, title, status
      }
      if (info === 'unfilter') {
        updatedTodos.splice(index, 0, newPayload)
      } else if (info === 'activeFilter') {
        updatedActiveTodos.splice(index, 0, newPayload)
        updatedTodos.splice(index, 0, newPayload)
      } else if (info === 'finishedFilter') {
        updatedFinishedTodos.splice(index, 0, newPayload)
        updatedTodos.splice(index, 0, newPayload)
      }
      return {...state, todos: updatedTodos, activeTodos: updatedActiveTodos, finishedTodos: updatedFinishedTodos}
    case DELETE_TODO:
      let afterDeletedTodos = state.todos.filter(todo => todo.id !== payload.id)
      let newActiveTodos = state.activeTodos.filter(todo => todo.id !== payload.id)
      let newFinishedTodos = state.finishedTodos.filter(todo => todo.id !== payload.id)
      return { ...state, todos: afterDeletedTodos, activeTodos: newActiveTodos, finishedTodos: newFinishedTodos }
    case SET_ACTIVE_TODOS:
      return { ...state, activeTodos: state.todos.filter(todo => todo.status === 'unfinished') }
    case SET_FINISHED_TODOS:
      return { ...state, finishedTodos: state.todos.filter(todo => todo.status === 'finished') }
    case DELETE_ACTIVE_TODO:
      let newerAllTodos = state.todos.filter(todo => todo.id !== payload.id)
      let newerActiveTodos = state.activeTodos.filter(todo => todo.id !== payload.id)
      return { ...state, todos: newerAllTodos, activeTodos: newerActiveTodos }
    case DELETE_FINISHED_TODO:
      let newestAllTodos = state.todos.filter(todo => todo.id !== payload.id)
      let newestFinishedTodos = state.finishedTodos.filter(todo => todo.id !== payload.id)
      return { ...state, todos: newestAllTodos, finishedTodos: newestFinishedTodos }
    default:
      return state
  }
}